<ng-template [ngIf]="!outlet.isActivated">
  <vnm-content-header header="theming-dashboard.title" info="theming-dashboard.info">
    <ng-template #contentActions>
      <button
        pButton
        [label]="'theming-dashboard.new-theme' | translate"
        (click)="newTheme()"
        icon="fa fa-plus"
      ></button>
    </ng-template>
  </vnm-content-header>
  <div class="content-body">
    <vnm-grid>
      <ng-template ngFor let-theme [ngForOf]="themeService.themes">
        <vnm-theme-card [theme]="theme"></vnm-theme-card>
      </ng-template>
    </vnm-grid>
  </div>
</ng-template>
<router-outlet #outlet="outlet"></router-outlet>
